import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Notification } from 'baseui/notification'
import { useStyletron } from 'baseui'
import { ListItemLabel } from 'baseui/list'

const NotificationField = ({ carBase, carHp, carHc, carGas }) => {
  const { t } = useTranslation()
  const [css] = useStyletron()
  const boldStyle = css({
    fontWeight: 'bold',
  })
  const CustomListItemLabel = ({ car, text }) => {
    return (
      <ListItemLabel
        description=''
        overrides={{
          LabelContent: {
            style: () => ({
              fontSize: '15px',
              color: 'rgb(20, 96, 170)',
            }),
          },
          LabelDescription: {
            style: () => ({
              fontSize: '10px',
            }),
          },
        }}
      >
        {text}
        <span className={boldStyle}>{Math.round(car)}</span>
        {t('subscriptionTools:estimator.kwh_text')}
      </ListItemLabel>
    )
  }

  return (
    <Notification
      overrides={{
        Body: {
          style: {
            width: 'auto',
            color: 'rgb(20, 96, 170)',
            backgroundColor: 'white',
            marginTop: 0,
            paddingTop: 0,
          },
        },
      }}
    >
      <div
        className={css({
          alignItems: 'center',
          display: 'block',
        })}
      >
        {typeof carBase !== 'undefined' && carBase !== null && carBase !== 0 && (
          <CustomListItemLabel car={carBase} text={t('subscriptionTools:estimator.car_elec_base_text')} />
        )}

        {typeof carHp !== 'undefined' && carHp !== null && carHp !== 0 && (
          <CustomListItemLabel car={carHp} text={t('subscriptionTools:estimator.car_elec_hp_text')} />
        )}

        {typeof carHc !== 'undefined' && carHc !== null && carHc !== 0 && (
          <CustomListItemLabel car={carHc} text={t('subscriptionTools:estimator.car_elec_hc_text')} />
        )}

        {typeof carGas !== 'undefined' && carGas !== null && carGas !== 0 && (
          <CustomListItemLabel car={carGas} text={t('subscriptionTools:estimator.car_gas_text')} />
        )}
      </div>
    </Notification>
  )
}

NotificationField.propTypes = {
  carBase: PropTypes.string,
  carHp: PropTypes.string,
  carHc: PropTypes.string,
  carGas: PropTypes.string,
}

export default NotificationField
